import { deriveNestedUserIds } from './overviewTableDataSelectorHelpers';
import { deriveNestedTeamIds } from './teamUtils';
export const canUserSubmitForecast = ({
  canEditAll,
  canEditOwned,
  canEditTeam,
  currentUserId,
  isUser,
  primaryTeam,
  targetEditId,
  teams
}) => {
  if (!isUser) {
    const nestedTeamIds = primaryTeam ? deriveNestedTeamIds(primaryTeam.id, teams) : [];
    return canEditAll || canEditTeam && primaryTeam && (targetEditId === primaryTeam.id || nestedTeamIds.includes(targetEditId));
  }
  const isOwner = currentUserId === targetEditId;
  const isOwnersTeam = teams.size && primaryTeam && deriveNestedUserIds(teams, primaryTeam.id).includes(targetEditId);
  return canEditAll || (canEditOwned || canEditTeam) && isOwner || canEditTeam && isOwnersTeam;
};